import React, { useState } from "react";
import { Header } from "../components/shared";
import { CheckoutFooter } from "../components/checkout";
import { BlogHero, BlogSearch, BlogGrid } from "../components/blog";
import { SEO, generateBreadcrumbSchema } from "../seo";

const Blog = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");

  const breadcrumbSchema = generateBreadcrumbSchema([
    { name: 'Home', path: '' },
    { name: 'Blog', path: '/blog' },
  ]);

  const handleSearchChange = (query) => {
    setSearchQuery(query);
    // Clear category when searching
    if (query.trim()) {
      setSelectedCategory("");
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    // Clear search when selecting category
    if (category) {
      setSearchQuery("");
    }
  };

  return (
    <div className="blog-page">
      <SEO schema={breadcrumbSchema} />
      <h1 className="sr-only">SunCatchers Van Life Blog - Portugal Travel Tips</h1>
      <div className="blog-main-container">
        <Header />
        <BlogHero />
        <div className="blog-content-section">
          <BlogSearch
            searchQuery={searchQuery}
            selectedCategory={selectedCategory}
            onSearchChange={handleSearchChange}
            onCategoryChange={handleCategoryChange}
          />
          <BlogGrid
            searchQuery={searchQuery}
            selectedCategory={selectedCategory}
          />
        </div>
        <CheckoutFooter />
      </div>
    </div>
  );
};

export default Blog;
